import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Form,
  H4,
  H6,
  InputTextArea,
} from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Icon } from "../../../components";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useSupplierUpdate } from "../../../hooks/api/v2/supplier/useSupplierUpdate";
import { useSellarSupplier } from "../../../hooks/useSellarSupplier";

export const StorefrontSettingsDescriptionCard = ({
  description,
}: {
  description: SupplierGetResponseType["description"];
}) => {
  const supplier = useSellarSupplier();

  const [modalActive, setModalActive] = useState(false);

  const supplierUpdateMutation = useSupplierUpdate(supplier.id);

  return (
    <Card className="bg-white">
      <CardHeader
        className={twMerge(
          "bg-white",
          "flex items-center justify-between gap-6 p-4",
        )}
      >
        <div>
          <H4>Description</H4>
          <H6>Tell your customers about your brand.</H6>
        </div>
        <Button color={"secondary"} onClick={() => setModalActive(true)}>
          <Icon icon={"PENCIL"} />
          Edit
        </Button>
      </CardHeader>
      <CardContent className={"p-4"}>
        <pre className={"whitespace-pre-wrap"}>{description}</pre>
      </CardContent>
      <StorefrontSettingsDescriptionModal
        description={description}
        loading={supplierUpdateMutation.isPending}
        active={modalActive}
        onDismiss={() => setModalActive(false)}
        onSubmit={(description) => {
          supplierUpdateMutation.mutate(
            {
              description,
            },
            {
              onSuccess: () => {
                setModalActive(false);
              },
            },
          );
        }}
      />
    </Card>
  );
};

const StorefrontSettingsDescriptionModal = ({
  description,
  loading,
  active,
  onDismiss,
  onSubmit,
}: {
  description: SupplierGetResponseType["description"];
  loading: boolean;
  active: boolean;
  onDismiss: () => void;
  onSubmit: (description: string | null) => void;
}) => {
  const { handleSubmit, register, formState } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      description,
    },
  });

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Description"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <Form
        className="flex w-full flex-col"
        onSubmit={handleSubmit((data) => {
          onSubmit(data.description || null);
        })}
      >
        <DialogContent>
          <InputLabel>Description</InputLabel>
          <InputContainer>
            <InputTextArea
              variant="legacyFixed"
              {...register("description", {
                required: false,
                disabled: loading,
              })}
              placeholder={"Description"}
            />
          </InputContainer>
        </DialogContent>

        <DialogCTA>
          <Button
            type={"submit"}
            className={"w-full"}
            loading={loading}
            disabled={!formState.isDirty}
          >
            Update
          </Button>
        </DialogCTA>
      </Form>
    </Dialog>
  );
};
